// removed by extract-text-webpack-plugin
module.exports = {"yx_yxCircle_sm":"yx_yxCircle_sm___-eS_H","fontSize_1":"fontSize_1___3Z5Qt","fontSize_2":"fontSize_2___2GGOv","fontSize_3":"fontSize_3___19mkf","fontSize_4":"fontSize_4___1GLdL","fontSize_5":"fontSize_5___2qjgd","fontSize_6":"fontSize_6___1kO37","fontColor_1":"fontColor_1___hX6nF","fontColor_2":"fontColor_2___2xR69","fontColor_3":"fontColor_3___1k2-U","fontColor_4":"fontColor_4___1KjQO","fontColor_5":"fontColor_5___8cHtu","fontColor_6":"fontColor_6___2yDbV"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/common.less
// module id = ./src/assets/css/common.less
// module chunks = 43